import { useState } from 'react'
import { Controller } from 'react-hook-form'
import AutoComplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import Axios from 'axios'
import { useTranslation } from 'next-i18next'
import { addressObjectToLabel } from '../utility/addressObjectUtility'

const AddressAutoComplete = ({ control, label, name, controllerProps, autoCompleteProps, textFieldProps }) => {

  // the field value from auto complete will be the option object
  // Option Object: { value, label }

  const [options, setOptions] = useState([])
  const [isInputInvalid, setInputInvalid] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isNotFound, setNotFound] = useState(false)

  const { t } = useTranslation('common')

  const updateOptions = (keyword) => {
    if (!keyword) {
      setInputInvalid(false)
      setNotFound(false)
      setOptions([])
      return
    }
    if (!keyword.match(/^[ก-๙0-9 :.-]+$/) || keyword.length < 3) {
      setInputInvalid(true)
      setNotFound(false)
      return
    }
    setInputInvalid(false)
    setLoading(true)
    Axios.post('/api/checkprice/auto-complete-address',{ query: keyword })
    .then((res) => {
      if ('searched' in res.data) {
        const options = res.data.searched.map((addr) => {
          return { label: addressObjectToLabel(addr), value: addr }
        })
        setOptions(options)
        setNotFound(false)
      }
    })
    .catch((err) => {
      setNotFound(true)
    })
    .finally(() => {
      setLoading(false)
    })
  }

  return (
    <Controller
      render={({onChange,value,...props}) => (
        <AutoComplete
          options={options}
          getOptionLabel={option => option.label ?? ''}
          getOptionSelected={(option, value) => {
            return option.label === value.label
          }}
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              error={isInputInvalid}
              placeholder={t('address-auto-complete-ex')}
              {...textFieldProps}
            />
          )}
          onChange={(e,value) => onChange(value)}
          value={value}
          onInputChange={(e,value,reason) => {
            if (reason === 'reset') {
              setInputInvalid(false)
            } else {
              updateOptions(value)
            }
          }}
          disableClearable
          noOptionsText={isInputInvalid ? t('invalid-address') : (isNotFound ? t('no-options') : t('please-search-address'))}
          loading={isLoading}
          loadingText={t('loading')}
          filterOptions={(option, _) => option}
          {...props}
          {...autoCompleteProps}
        />
      )}
      defaultValue={null}
      name={name}
      control={control}
      {...controllerProps}
    />
  )
}

export default AddressAutoComplete